import { Link } from "react-router-dom";
import type { Anime } from "@/mocks/anime";
import { useFavorites } from "@/hooks/useFavorites";

interface AnimeCardProps {
  anime: Anime;
  size?: "sm" | "md";
}

export default function AnimeCard({ anime, size = "md" }: AnimeCardProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const favorited = isFavorite(anime.id);

  return (
    <article className="group relative" data-product-shop>
      <Link to={`/detail/${anime.id}`} className="block cursor-pointer">
        <div className="relative w-full aspect-[5/7] overflow-hidden rounded-lg bg-background-200">
          <img
            src={anime.cover}
            alt={`${anime.title} 封面海报`}
            title={`${anime.title} - 高清动漫在线观看`}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-primary-950/80 to-transparent" />
          <span className="absolute left-2 top-2 px-1.5 py-0.5 rounded bg-primary-950/75 text-background-50 text-[11px] leading-4">
            {anime.year}
          </span>
          <span className="absolute bottom-2 left-2 flex items-center gap-1 text-[11px] text-background-50">
            <i className="ri-play-circle-fill text-accent-400 text-xs" />
            更新至 {anime.episodes} 集
          </span>
        </div>
        <h3
          className={`mt-2 font-heading font-semibold text-foreground-950 leading-snug line-clamp-2 group-hover:text-primary-600 transition-colors ${
            size === "sm" ? "text-[13px]" : "text-sm"
          }`}
        >
          {anime.title}
        </h3>
        <div className="mt-1 flex items-center gap-1.5 text-[11px] text-foreground-500">
          <span className="flex items-center gap-0.5 text-accent-600">
            <i className="ri-star-fill text-[11px]" />
            {anime.rating.toFixed(1)}
          </span>
          <span className="text-background-400">·</span>
          <span className="truncate">{anime.categories.slice(0, 2).join(" / ")}</span>
        </div>
      </Link>
      <button
        type="button"
        aria-label={favorited ? `取消收藏 ${anime.title}` : `收藏 ${anime.title}`}
        onClick={() => toggleFavorite(anime.id)}
        className={`absolute right-2 top-2 w-7 h-7 rounded-full flex items-center justify-center cursor-pointer transition-colors ${
          favorited
            ? "bg-accent-500 text-background-50"
            : "bg-background-50/85 text-foreground-700 hover:bg-background-50"
        }`}
      >
        <i className={`${favorited ? "ri-heart-3-fill" : "ri-heart-3-line"} text-[13px]`} />
      </button>
    </article>
  );
}